module.exports = __webpack_public_path__ + "img/fullsizeoutput_99c8.b4d3c1ac.b4d3c1ac.jpeg";